// @ts-nocheck
/* eslint-disable */
export const appPlus32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 10V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M21.5 15.5L10.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'plus-32' as const
};